import { computed } from '@vue/composition-api';
import { date } from '@/util/formatters';
import { DummyFilter } from '@/components/Table/dummy-filter';
export const useSurveyUsersColumns = (ctx) => {
    const columns = computed(() => {
        return [
            {
                field: 'user.place.number',
                headerName: ctx.root
                    .$t('brand-surveys.details.place-number')
                    .toString(),
                valueGetter: (params) => params.data?.user?.place?.number || '-',
                sortable: true,
                width: 150,
                minWidth: 150,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressHeaderFilterButton: true,
                suppressFloatingFilterButton: true,
            },
            {
                field: 'user.place.name',
                headerName: ctx.root.$t('brand-surveys.details.place-name').toString(),
                valueGetter: (params) => params.data?.user?.place?.name || '-',
                sortable: true,
                minWidth: 350,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressHeaderFilterButton: true,
                suppressFloatingFilterButton: true,
            },
            {
                field: 'user.fullName',
                headerName: ctx.root.$t('brand-surveys.details.full-name').toString(),
                valueGetter: (params) => params.data?.user?.fullName || '-',
                sortable: true,
                flex: 1,
                minWidth: 350,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressHeaderFilterButton: true,
                suppressFloatingFilterButton: true,
                cellStyle: { fontWeight: 300 },
            },
            {
                field: 'publishedAt',
                headerName: ctx.root
                    .$t('brand-surveys.details.published-at')
                    .toString(),
                minWidth: 232,
                width: 220,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingDatepickerFiler',
                suppressFloatingFilterButton: true,
                suppressHeaderFilterButton: true,
                cellRenderer: (params) => date(params?.data?.createdAt),
                cellStyle: { fontWeight: 300 },
            },
            {
                field: 'reminderCounter',
                headerName: ctx.root
                    .$t('brand-surveys.details.reminder-count')
                    .toString(),
                valueGetter: (params) => params.data?.reminderCounter ?? 0,
                sortable: true,
                width: 200,
                minWidth: 200,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressHeaderFilterButton: true,
                suppressFloatingFilterButton: true,
                cellStyle: { fontWeight: 300 },
            },
            {
                field: 'answers',
                headerName: ctx.root.$t('brand-surveys.details.answered').toString(),
                sortable: true,
                width: 200,
                minWidth: 200,
                cellRenderer: 'SurveyAnsweredBadge',
                cellStyle: { fontWeight: 300 },
                cellRendererParams: (params) => ({
                    isAnswered: (params?.data?.answers?.length ?? 0) > 0,
                }),
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingSelectFilter',
                floatingFilterComponentParams: () => ({
                    zIndex: 100,
                    options: [
                        {
                            label: ctx.root.$t('common.yes').toString(),
                            value: true,
                        },
                        {
                            label: ctx.root.$t('common.no').toString(),
                            value: false,
                        },
                    ],
                }),
                suppressHeaderFilterButton: true,
                suppressFloatingFilterButton: true,
            },
        ];
    });
    return { columns };
};
